import i18n from 'i18n/config'
import Handlers from 'types/Handlers'
import { OutputFormat } from 'types/OutputFormat'

const endpoint = process.env.REACT_APP_API_ENDPOINT || ''

export const createEnhancementRequest = async (
  deviceId: string,
  image: File,
  handler: `${Handlers}` = Handlers.THOMAS_JEFFERSON,
  outputFormat: OutputFormat = 'jpeg',
  token?: string,
) => {
  const formData = new FormData()
  formData.append('files', image)
  formData.append('outputFormat', outputFormat)
  formData.append('handler', handler)

  const result = await fetch(`${endpoint}/requests`, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Device-Id': deviceId,
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
    },
  })

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return result.json()
}

export const createGenerationRequest = async (
  deviceId: string,
  text: string,
  token?: string,
  handler: `${Handlers}` = Handlers.JOHN_ADAMS,
) => {
  const formData = new FormData()
  formData.append('text', text)
  formData.append('handler', handler)

  const result = await fetch(`${endpoint}/requests`, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Device-Id': deviceId,
      ...(token && {
        Authorization: `Bearer ${token}`,
      }),
    },
  })

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return result.json()
}

export const getRequest = async (deviceId: string, requestId: number) => {
  const result = await fetch(`${endpoint}/requests/${requestId}`, {
    method: 'GET',
    headers: {
      'X-Device-Id': deviceId,
    },
  })

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return result.json()
}

export const getRequests = async (
  deviceId: string,
  sourceType: 'image' | 'text',
  page: number = 1,
  take: number = 12,
) => {
  const result = await fetch(
    `${endpoint}/requests?source_type=${sourceType}&page=${page}&take=${take}`,
    {
      method: 'GET',
      headers: {
        'X-Device-Id': deviceId,
      },
    },
  )

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return result.json()
}

export const getAllRequests = async (
  token: string,
  sourceType: 'image' | 'text',
  page: number = 1,
  take: number = 1,
) => {
  const result = await fetch(
    `${endpoint}/requests/user/all?source_type=${sourceType}&page=${page}&take=${take}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return result.json()
}

export const linkDeviceToUser = async (deviceId: string, token: string) => {
  const result = await fetch(`${endpoint}/login`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Device-Id': deviceId,
    },
  })

  if (!result.ok) throw new Error(`${i18n.t('error.api')}: ${result.status}`)

  return result.json()
}

export const fetchImage = async (imageUrl: string): Promise<File> => {
  // TODO: разобраться с CORS Amazon'а
  const result = await fetch(imageUrl)
  const blob = await result.blob()
  const fileName = Date.now()
  return new File([blob], `${fileName}.jpg`, { type: blob.type })
}
